import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"

import {TROPHY_SIZE} from "../constants"

interface StyledProps {
  isTrophySelected: boolean
}

const TrophyWrapper = styled<StyledProps, "div">("div")`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  ${minWidthMedia.tablet`
    position: relative;
  `}
  ${({isTrophySelected}) =>
    !isTrophySelected &&
    `
    transition: width 0.5s ease;
    width: ${TROPHY_SIZE}px;
    margin-left: 20px;
    justify-content: flex-start;
  `}
`
export default TrophyWrapper
